/* @flow */

import { verticalSlidingDuration } from '@e180/ui/lib/token/animation';
import { baseColor } from '@e180/ui/lib/token/color';
import { navDrawerElevation } from 'src/shared/app/base/style/token/elevation';
import { aaDarkGrey } from '@e180/ui/lib/token/palette';

export default {
  root: {
    position: 'relative',
    width: '100%',
    height: '100%',

    backgroundColor: baseColor,

    transition: `transform ${verticalSlidingDuration} ease-out`,
  },
  'root-isHidden': {
    transform: 'translate3d(0, 100%, 0)',
  },
  closeBtn: {
    position: 'absolute',
    top: 0,
    left: 0,
    /* Dirty */
    zIndex: navDrawerElevation + 1,

    fill: aaDarkGrey,
  },
};
